<template>
	<div style="padding: 10px 10px 10px 0;">
		<el-form :inline="true" :model="selectForm" class="demo-form-inline">
			<div class="flex sb">
				<div>
					<el-form-item label="所属楼层">
						<el-select v-model="selectForm.storey" placeholder="所属楼层" clearable>
							<el-option v-for="item in 5" :label="`${item}楼`" :value="`${item}楼`"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="商铺号">
						<el-input v-model="selectForm.shopNum" placeholder="商铺号" clearable></el-input>
					</el-form-item>
					<el-form-item label="商铺状态">
						<el-select v-model="selectForm.status">
							<el-option label="正常" value="正常"></el-option>
							<el-option label="停用" value="停用"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="商铺名称">
						<el-input v-model="selectForm.shopName" placeholder="商铺名称" clearable></el-input>
					</el-form-item>
					<!-- <el-form-item label="联系人">
							<el-input v-model="selectForm.linkName" placeholder="联系人" clearable></el-input>
						</el-form-item>
						<el-form-item label="联系方式">
							<el-input v-model="selectForm.linkPhone" placeholder="联系方式" clearable></el-input>
						</el-form-item> -->
					<el-form-item>
						<el-button type="primary" @click="query()">查询</el-button>
					</el-form-item>
					<!-- <el-form-item>
							<el-button type="primary" @click="dc">导出</el-button>
						</el-form-item> -->
				</div>
	
			</div>
		</el-form>
		<el-table :data="data" style="width: 100%">
			<el-table-column prop="storey" label="楼层" width="100"></el-table-column>
			<el-table-column prop="shopNum" label="商铺编号"></el-table-column>
			<el-table-column prop="shopName" label="商铺名称"></el-table-column>
			<el-table-column prop="brandName" label="经营品牌"></el-table-column>
			<!-- <el-table-column prop="area" label="出租面积"></el-table-column> -->
			<el-table-column prop="shopFormat" label="经营业态"></el-table-column>
			<el-table-column prop="linkName" label="联系人"></el-table-column>
			<el-table-column prop="linkPhone" label="联系电话"></el-table-column>
			<!--<el-table-column prop="linkCard" label="身份证号"></el-table-column> -->
			<el-table-column prop="status" label="商铺状态"></el-table-column>
			<el-table-column prop="date" label="操作" width="180" align="center">
				<template slot-scope="{row}">
						<el-button type="text" @click="setRow(row)">常用账户</el-button>
</template>
			</el-table-column>
		</el-table>
		<el-pagination :page-sizes="[10, 20, 30, 50]" :page-size="selectForm.pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total="count" @size-change="handleSizeChange"
			@current-change="handleCurrentChange">
		</el-pagination>


		<el-dialog title="常用账户" :visible.sync="show3">
			<el-button type="primary" size="small" @click="addRow">新增</el-button>
			<el-dialog title="新增常用账户" :visible.sync="innerVisible" append-to-body>



			</el-dialog>
			<el-table :data="data" style="width: 100%">
				<el-table-column prop="storey" label="楼层" width="100"></el-table-column>
				<el-table-column prop="shopNum" label="商铺编号"></el-table-column>
				<el-table-column prop="shopName" label="商铺名称"></el-table-column>
				<el-table-column prop="brandName" label="经营品牌"></el-table-column>
				<el-table-column prop="date" label="操作" width="180" align="center">
<template slot-scope="{row}">
	<el-button type="text" @click="delRow(row)">
		删除</el-button>
</template>
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>

<script>
import publicExport from '../../../assets/js/publicExport.js';
export default {
	data() {
		return {
			count: 0,
			selectForm: {
				status: null,
				currentPage: 1,
				pageSize: 10,
				shopNum: null, //商铺号
				storey: null, //楼层
				shopName: null,
				linkName: null,
				linkPhone: null
			},
			data: [],
			show: false,
			innerVisible: false,
		}
	},
	methods: {
		setRow(obj) {
			this.show = true;

		},
		delRow(obj) {

		},
		addRow() {
			this.innerVisible = true;
		},
		dc() {
			publicExport("/api/bdShop/exportShop", this.selectForm, "商铺信息")
		},


		getAll() {
			this.$http.post("/api/bdShop/queryShop", this.selectForm).then(res => {
				this.data = res.data.data.items
				this.count = res.data.data.totalNum
			})
		},
		query() {
			this.selectForm.currentPage = 1;
			this.getAll()
		},
		handleCurrentChange(val) {
			this.selectForm.currentPage = val;
			this.getAll()
		},
		handleSizeChange(val) {
			this.selectForm.pageSize = val;
			this.getAll()
		},

	},
	created() {
		this.getAll();
	}
}
</script>

<style scoped="scoped">

</style>
